import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SubmissionStatus } from '../../../components';
import LikedByPopup from '../../../features/collection/components/liked-by-popup';
import { RejectionPopup } from '../../../features/collection/components/rejection-popup';
import { useInternationalization } from '../../../features/i18n';
import { useViewport } from '../../../utils';

const SidebarStatus = ({isEdit}) => {
  const { needRevisionId } = useSelector(state => state.system)
  const form = useSelector(state => state.blogForm.data)
  const [showLikedBy, setShowLikedBy] = useState(false)
  const [showBookmarkedBy, setShowBookmarkedBy] = useState(false)
  const {
    likes,
    total_likes,
    bookmarks,
    total_bookmarks
  } = useSelector(state => state.blog.data)
  const {
    submission_status_id,
    reason
  } = form
  const [rejectionPopedUp, setRejectionPopedUp] = useState(false)
  const { translate } = useInternationalization()
  const { isDesktop } = useViewport()

  const showReasonTrigger = submission_status_id === needRevisionId

  return <>
    {
      isEdit &&
      <div
        className={`mobile-fullwidth ${isDesktop ? 'mb-5' : 'text-center p-6 mb-8'}`}
        style={{background: isDesktop ? 'initial' : '#f5f5f5'}}
      >
        <p className="text-sm text-gray-444">
          Status: <strong><SubmissionStatus value={submission_status_id}/></strong>
        </p>
        {
          showReasonTrigger &&
          <p className="link mb-5" onClick={() => setRejectionPopedUp(true)}>
            {translate('GENERAL', 'what_to_fix')}
          </p>
        }
        <p className="text-sm text-gray-444">
          {translate('LIKE', 'liked_by')}: <strong onClick={() => setShowLikedBy(true)} className="underline cursor-pointer">
            {total_likes}
          </strong>
        </p>
        <p className="text-sm text-gray-444">
          {translate('BOOKMARK', 'bookmarked_by')}: <strong onClick={() => setShowBookmarkedBy(true)} className="underline cursor-pointer">
            {total_bookmarks}
          </strong>
        </p>
      </div>
    }
    {
      rejectionPopedUp &&
      <RejectionPopup onClose={setRejectionPopedUp} content={reason}/>
    }
    {
      showLikedBy &&
      <LikedByPopup onClose={() => setShowLikedBy(false)} data={likes}/>
    }
    {
      showBookmarkedBy &&
      <LikedByPopup
        onClose={() => setShowBookmarkedBy(false)}
        data={bookmarks}
        title={`${translate('BOOKMARK', 'bookmarked_by')}: ${total_bookmarks} User(s)`}
      />
    }
  </>
}

export { SidebarStatus }
